// Everything this slice caches. A write moves the gate itself, so it invalidates at THIS level and
// not at the count's: the per-location read hangs off a sibling of `count`, and a write that only
// invalidated counts would leave the lookup card asserting the state it had before the wave.
export const DOOR_ACCESS_PREFIX = ['amazon-door-access'] as const;

// The counts' own prefix, which is what lets one invalidation reach BOTH counters instead of each
// caller having to know every key.
export const DOOR_ACCESS_COUNT_PREFIX = [...DOOR_ACCESS_PREFIX, 'count'] as const;

export const doorAccessCountKey = (enabled: boolean) => [...DOOR_ACCESS_COUNT_PREFIX, enabled];

// The per-location read, SIBLING of `count` under the slice prefix — which is what puts it within
// reach of the batch write's single `invalidateQueries({queryKey: DOOR_ACCESS_PREFIX})`.
//
// It takes `null` on purpose: the read is skipped with `skipToken` while nobody has submitted an id,
// and the null id goes into the key as itself rather than through an invented sentinel that could
// collide with a real one.
export const doorAccessLocationKey = (locationId: number | null) => [
  ...DOOR_ACCESS_PREFIX,
  'location',
  locationId,
];
